import {SelectInput} from 'react-admin';
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {api} from "../../../api/apiProvider";

export default function SidSelect () {
    const {t} = useTranslation()
    const [choices, setChoices] = useState([])

    useEffect(() => {
        async function fetchData() {
            const response = await api.get('/dictionary/available_sids')
            if (response && response.data) {
                setChoices(response.data.map((sid) => ({
                    id: sid.id,
                    name: sid.name,
                })))
            }
        }
        fetchData();
    }, []);

    return (
        <SelectInput
            source="sid"
            choices={choices}
            optionText="name"
            optionValue="id"
            label={t('common.choose')}
        />
    );
};
